module.exports = __webpack_public_path__ + "static/img/header_01.d130daec.png";